import React from 'react';
import { Row, Col } from 'react-bootstrap';
import TextContent from '../../../_common/TextContent';
import '../EquipmentProfile.scss';

interface EquipmentLoadDetailsProps {
    assetLoadType?: string | null;
    status?: string | null;
    miles?: number | null;
    accessorialCost?: number | null;
    payCode?: string | null;
}

const  EquipmentLoadDetails = ({
    assetLoadType,
    status,
    miles,
    accessorialCost,
    payCode,
}: EquipmentLoadDetailsProps): React.ReactElement => {
    return (
        <Col>
            <Row className="LoadDetail-Title">Load Details</Row>
            <Row className="EquipmentDetail-Status">
                <TextContent hasTopMargin title={'Status: '} value={status || ''} />
            </Row>
            <Row>
                <TextContent hasTopMargin title={'Load Type: '} value={assetLoadType || ''} />
            </Row>
            <Row>
                <TextContent hasTopMargin title={'Miles: '} value={miles?.toString() || ''} />
            </Row>
            <Row>
                <TextContent hasTopMargin title={'Accessorial Cost: '} value={accessorialCost?.toString() || ''} />
            </Row>
            <Row>
                <TextContent hasTopMargin title={'Paycode: '} value={payCode || ''} />
            </Row>
        </Col>
    );
};

export default EquipmentLoadDetails;
